import * as React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export function BedIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.3333 6.87133V2.5H11.9999V3.83333H3.99992V2.5H2.66659V6.87133C1.87325 7.33333 1.33325 8.18333 1.33325 9.16667V11.8333C1.33325 12.0101 1.40349 12.1797 1.52851 12.3047C1.65354 12.4298 1.82311 12.5 1.99992 12.5H2.66659V15.1667H3.99992V12.5H11.9999V15.1667H13.3333V12.5H13.9999C14.1767 12.5 14.3463 12.4298 14.4713 12.3047C14.5963 12.1797 14.6666 12.0101 14.6666 11.8333V9.16667C14.6666 8.18333 14.1259 7.33333 13.3333 6.87133ZM11.9999 5.16667V6.5H8.66659V5.16667H11.9999ZM3.99992 5.16667H7.33325V6.5H3.99992V5.16667ZM13.3333 11.1667H2.66659V9.16667C2.66659 8.43133 3.26459 7.83333 3.99992 7.83333H11.9999C12.7353 7.83333 13.3333 8.43133 13.3333 9.16667V11.1667Z"
          fill="#054D87"
        />
      </svg>
    </SvgIcon>
  );
}
export function ShowerIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.2 13.564C15.0512 12.583 14.6361 11.6615 14 10.9C13.3621 11.6604 12.9468 12.5824 12.8 13.564C12.7804 13.7332 12.7969 13.9047 12.8482 14.0671C12.8996 14.2295 12.9848 14.3792 13.0981 14.5064C13.2114 14.6336 13.3503 14.7354 13.5058 14.8051C13.6612 14.8748 13.8297 14.9108 14 14.9108C14.1704 14.9108 14.3388 14.8748 14.4942 14.8051C14.6497 14.7354 14.7886 14.6336 14.9019 14.5064C15.0152 14.3792 15.1004 14.2295 15.1518 14.0671C15.2031 13.9047 15.2196 13.7332 15.2 13.564ZM7.2 15.164C7.05121 14.183 6.63615 13.2615 6 12.5C5.36209 13.2604 4.9468 14.1824 4.8 15.164C4.78255 15.5001 4.89905 15.8295 5.12397 16.0799C5.3489 16.3303 5.66391 16.4814 6 16.5C6.33609 16.4814 6.6511 16.3303 6.87603 16.0799C7.10095 15.8295 7.21745 15.5001 7.2 15.164ZM10 16.5C10.3361 16.4814 10.6511 16.3303 10.876 16.0799C11.101 15.8295 11.2175 15.5001 11.2 15.164C11.0512 14.183 10.6361 13.2615 10 12.5C9.36209 13.2604 8.9468 14.1824 8.8 15.164C8.78255 15.5001 8.89905 15.8295 9.12397 16.0799C9.3489 16.3303 9.66391 16.4814 10 16.5ZM0.8 13.564C0.78255 13.9001 0.899049 14.2295 1.12397 14.4799C1.3489 14.7303 1.66391 14.8814 2 14.9C2.33609 14.8814 2.6511 14.7303 2.87603 14.4799C3.10095 14.2295 3.21745 13.9001 3.2 13.564C3.05121 12.583 2.63615 11.6615 2 10.9C1.36209 11.6604 0.946796 12.5824 0.8 13.564ZM8.8 2.156V0.5H7.2V2.156C5.65438 2.35073 4.23286 3.10252 3.20192 4.27042C2.17098 5.43833 1.60141 6.94217 1.6 8.5H0V10.1H16V8.5H14.4C14.3986 6.94217 13.829 5.43833 12.7981 4.27042C11.7671 3.10252 10.3456 2.35073 8.8 2.156ZM3.2 8.5C3.2 7.22696 3.70571 6.00606 4.60589 5.10589C5.50606 4.20571 6.72696 3.7 8 3.7C9.27304 3.7 10.4939 4.20571 11.3941 5.10589C12.2943 6.00606 12.8 7.22696 12.8 8.5H3.2Z"
          fill="#054D87"
        />
      </svg>
    </SvgIcon>
  );
}
export function SquareFootIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.33325 1.83325H7.99992V8.49992H14.6666V15.1666H1.33325V1.83325ZM2.66659 3.16659V4.83325H4.00259V6.16659H2.66659V7.83325H4.00259V9.16659H2.66659V10.8333H4.00259V12.1666H2.66659V13.8333H4.33325V12.5219H5.66659V13.8333H7.33325V12.5219H8.66659V13.8333H10.3333V12.5219H11.6666V13.8333H13.3333V9.83325H6.66659V3.16659H2.66659Z"
          fill="#054D87"
        />
      </svg>
    </SvgIcon>
  );
}
export function MarkerIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7 8.1665C8.10457 8.1665 9 7.27107 9 6.1665C9 5.06193 8.10457 4.1665 7 4.1665C5.89543 4.1665 5 5.06193 5 6.1665C5 7.27107 5.89543 8.1665 7 8.1665Z"
          stroke="#054D87"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.00008 0.833252C5.58559 0.833252 4.22904 1.39516 3.22885 2.39535C2.22865 3.39554 1.66675 4.7521 1.66675 6.16659C1.66675 7.42792 1.93475 8.25325 2.66675 9.16659L7.00008 14.1666L11.3334 9.16659C12.0654 8.25325 12.3334 7.42792 12.3334 6.16659C12.3334 4.7521 11.7715 3.39554 10.7713 2.39535C9.77112 1.39516 8.41457 0.833252 7.00008 0.833252Z"
          stroke="#054D87"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
export function ShareIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.5 8.5V12.5C2.5 12.7652 2.60536 13.0196 2.79289 13.2071C2.98043 13.3946 3.23478 13.5 3.5 13.5H12.5C12.7652 13.5 13.0196 13.3946 13.2071 13.2071C13.3946 13.0196 13.5 12.7652 13.5 12.5V8.5M8 10V1.75M11 4.5L8 1.5L5 4.5"
          stroke="#054D87"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
export function CubeIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.2708 4.05742L8.27083 1.39076C8.18551 1.35284 8.09319 1.33325 7.99983 1.33325C7.90647 1.33325 7.81415 1.35284 7.72883 1.39076L1.72883 4.05742C1.7155 4.06342 1.70616 4.07342 1.69283 4.08076C1.67416 4.09009 1.65416 4.09609 1.63683 4.10742C1.62216 4.11742 1.61083 4.13009 1.59683 4.14076C1.5481 4.17697 1.50536 4.22061 1.47016 4.27009C1.45683 4.28876 1.44283 4.30542 1.43083 4.32409C1.41099 4.35932 1.39404 4.39611 1.38016 4.43409C1.37416 4.45209 1.36483 4.46876 1.3595 4.48676C1.34275 4.54531 1.33401 4.60586 1.3335 4.66676V11.3334C1.3335 11.5974 1.48816 11.8354 1.7295 11.9428L7.7295 14.6094C7.81616 14.6481 7.90816 14.6668 8.00016 14.6668C8.09299 14.6644 8.18428 14.6426 8.26816 14.6028L8.27083 14.6094L14.2708 11.9428C14.3888 11.8905 14.489 11.805 14.5593 11.6969C14.6296 11.5887 14.6669 11.4624 14.6668 11.3334V4.66676C14.6669 4.53775 14.6296 4.41149 14.5593 4.30332C14.489 4.19515 14.3888 4.10972 14.2708 4.05742ZM8.00016 2.73009L12.3588 4.66676L8.00016 6.60342L3.64216 4.66676L8.00016 2.73009ZM2.66683 10.9008V5.69275L7.3335 7.76676V12.9741L2.66683 10.9008ZM8.66683 12.9741V7.76676L13.3335 5.69275V10.9008L8.66683 12.9741Z"
          fill={props.color || "black"}
        />
      </svg>
    </SvgIcon>
  );
}
export function InPersonIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6 14.0001V10.0001C6 9.64646 6.14048 9.30732 6.39052 9.05727C6.64057 8.80722 6.97971 8.66675 7.33333 8.66675H8.66667C8.83133 8.66675 8.98933 8.69675 9.13467 8.75141"
          stroke={props.color || "black"}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.6667 8H14L8 2L2 8H3.33333V12.6667C3.33333 13.0203 3.47381 13.3594 3.72386 13.6095C3.97391 13.8595 4.31304 14 4.66667 14H8M10.6667 14.6667L14 11.3333M14 11.3333V14.3333M14 11.3333H11"
          stroke={props.color || "black"}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
export function InVideoIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.49967 11.9999H8.50634M5.16634 1.33325H11.833C12.5694 1.33325 13.1663 1.93021 13.1663 2.66659V13.3333C13.1663 14.0696 12.5694 14.6666 11.833 14.6666H5.16634C4.42996 14.6666 3.83301 14.0696 3.83301 13.3333V2.66659C3.83301 1.93021 4.42996 1.33325 5.16634 1.33325Z"
          stroke={props.color || "black"}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
export function StreetViewIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.83203 2C7.73203 2 6.83203 2.9 6.83203 4C6.83203 4.5565 7.07053 5.0585 7.44153 5.422C7.10132 5.65179 6.8224 5.96122 6.62903 6.32338C6.43566 6.68554 6.33371 7.08946 6.33203 7.5V9.8125L7.33203 10.3125V12.5H10.332V10.3125L11.332 9.8125V7.5C11.3304 7.08946 11.2284 6.68554 11.035 6.32338C10.8417 5.96122 10.5627 5.65179 10.2225 5.422C10.5935 5.0585 10.832 4.557 10.832 4C10.832 2.9 9.93203 2 8.83203 2ZM8.83203 3C9.39053 3 9.83203 3.4415 9.83203 4C9.83203 4.5585 9.39053 5 8.83203 5C8.27353 5 7.83203 4.5585 7.83203 4C7.83203 3.4415 8.27353 3 8.83203 3ZM8.83203 6C9.66603 6 10.332 6.666 10.332 7.5V9.1875L9.33203 9.6875V11.5H8.33203V9.6875L7.33203 9.1875V7.5C7.33203 6.666 7.99803 6 8.83203 6ZM5.33203 9.4375C3.87303 9.8455 2.83203 10.5375 2.83203 11.5C2.83203 13.1405 5.84953 14 8.83203 14C11.8145 14 14.832 13.1405 14.832 11.5C14.832 10.537 13.791 9.8455 12.332 9.4375V10.4845C13.283 10.791 13.832 11.1875 13.832 11.5C13.832 12.0975 11.838 13 8.83203 13C5.82603 13 3.83203 12.0975 3.83203 11.5C3.83203 11.1875 4.38103 10.791 5.33203 10.4845V9.4375Z"
          fill={props?.color || "white"}
        />
      </svg>
    </SvgIcon>
  );
}
export function SendMessageIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.16602 15.0001V18.1384L9.39685 15.0001H13.3327C14.2518 15.0001 14.9993 14.2526 14.9993 13.3334V6.66675C14.9993 5.74758 14.2518 5.00008 13.3327 5.00008H3.33268C2.41352 5.00008 1.66602 5.74758 1.66602 6.66675V13.3334C1.66602 14.2526 2.41352 15.0001 3.33268 15.0001H4.16602ZM3.33268 6.66675H13.3327V13.3334H8.93518L5.83268 15.1951V13.3334H3.33268V6.66675Z"
          fill="#054D87"
        />
        <path
          d="M16.666 1.66675H6.66602C5.74685 1.66675 4.99935 2.41425 4.99935 3.33341H14.9993C15.9185 3.33341 16.666 4.08091 16.666 5.00008V11.6667C17.5852 11.6667 18.3327 10.9192 18.3327 10.0001V3.33341C18.3327 2.41425 17.5852 1.66675 16.666 1.66675Z"
          fill="#054D87"
        />
      </svg>
    </SvgIcon>
  );
}
export function DoubleChatIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.33301 29.9999V36.2766L18.7947 29.9999H26.6663C28.5047 29.9999 29.9997 28.5049 29.9997 26.6666V13.3333C29.9997 11.4949 28.5047 9.99992 26.6663 9.99992H6.66634C4.82801 9.99992 3.33301 11.4949 3.33301 13.3333V26.6666C3.33301 28.5049 4.82801 29.9999 6.66634 29.9999H8.33301ZM6.66634 13.3333H26.6663V26.6666H17.8713L11.6663 30.3899V26.6666H6.66634V13.3333Z"
          fill={props.color || "#666666"}
        />
        <path
          d="M33.333 3.33325H13.333C11.4947 3.33325 9.99967 4.82825 9.99967 6.66659H29.9997C31.838 6.66659 33.333 8.16159 33.333 9.99992V23.3333C35.1713 23.3333 36.6663 21.8383 36.6663 19.9999V6.66659C36.6663 4.82825 35.1713 3.33325 33.333 3.33325Z"
          fill={props.color || "#666666"}
        />
      </svg>
    </SvgIcon>
  );
}
export function CheckedIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1004_2173)">
          <path
            d="M18.3332 9.23355V10.0002C18.3321 11.7972 17.7503 13.5458 16.6743 14.9851C15.5983 16.4244 14.0859 17.4773 12.3626 17.9868C10.6394 18.4963 8.79755 18.4351 7.1119 17.8124C5.42624 17.1896 3.98705 16.0386 3.00897 14.5311C2.03089 13.0236 1.56633 11.2403 1.68457 9.44714C1.80281 7.65402 2.49751 5.94715 3.66507 4.58111C4.83263 3.21506 6.41049 2.26303 8.16333 1.867C9.91617 1.47097 11.7501 1.65216 13.3915 2.38355M18.3332 3.33355L9.99984 11.6752L7.49984 9.17521"
            stroke={props.color || "#18A874"}
            stroke-width="1.75"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1004_2173">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
